import { pattern, string } from "superstruct";

export const postalCodeSchema = pattern(string(), /^[0-9]{5}$/);
